<template>
    <tfoot>
    <tr class="text-right">
        <td :colspan="colspan">{{ $t('subtotal') }}</td>
        <td class="text-nowrap">{{ invoice.subTotal | currency }}</td>
    </tr>
    <tr class="text-right" v-for="tax in invoice.taxes" :key="tax.label">
        <td :colspan="colspan">
            {{ tax.label }} ({{ tax.rate }}%)
        </td>
        <td class="text-nowrap">{{ tax.total | currency }}</td>
    </tr>
    <tr class="text-right" :class="{'d-print-none': !invoice.tax_rate}">
        <td :colspan="colspan">
            {{ $t('tax') }}
            <AppEditable :value="invoice.tax_rate | currency"
                         :errors="errors"
                         suffix="%"
                         field="tax_rate"
                         :placeholder="$t('add_tax_rate')"
                         @change="updateProp({ tax_rate: $event.replace(/\s/g, '') })"/>
        </td>
        <td class="text-nowrap">{{ invoice.globalTaxAmount | currency }}</td>
    </tr>
    <tr class="text-right">
        <th :colspan="colspan">
            {{ $t('total') }}
            <AppEditable :value="invoice.currency"
                         :errors="errors"
                         field="currency"
                         :placeholder="$t('add_currency')"
                         @change="updateProp({ currency: $event })"/>
        </th>
        <th class="text-nowrap">{{ invoice.total | currency }}</th>
    </tr>
    <!-- Advance Payments -->
    <tr v-for="(payment, index) in advancePayments" :key="payment.id">
        <td class="position-relative">
            <AppEditable :value="payment.description"
                         :errors="errors"
                         :field="`advance_payments.${index}.description`"
                         :placeholder="$t('enter_description')"
                         @change="updatePayment({ description: $event }, payment)"/>
            <button class="btn btn-sm d-print-none invoice__row-control"
                    @click="removePayment(payment.id)">
                <i class="material-icons md-18">remove</i>
            </button>
        </td>
        <td :colspan="colspan - 1"></td>
        <td class="text-right text-nowrap">
            <AppEditable :value="payment.amount | currency"
                         :errors="errors"
                         :field="`advance_payments.${index}.amount`"
                         :placeholder="$t('enter_amount')"
                         @change="updatePayment({ amount: $event.replace(/\s/g, '') }, payment)"/>
        </td>
    </tr>
    <tr class="text-right d-print-none">
        <td :colspan="colspan">
            <button class="btn btn-sm btn-link p-0" @click="addPayment">
                <i class="material-icons md-18">add</i>
                {{ $t('add_advance_payment') }}
            </button>
        </td>
        <td></td>
    </tr>
    </tfoot>
</template>
<script>
import { mapGetters } from 'vuex';
import AppEditable from '../form/AppEditable';
import { formatCurrency } from '../../filters/currency.filter';

export default {
  i18nOptions: { namespaces: 'invoice-totals' },
  props: ['invoice', 'errors'],
  components: {
    AppEditable,
  },
  filters: {
    currency: formatCurrency,
  },
  computed: {
    ...mapGetters({
      taxes: 'invoiceRows/taxes',
    }),
    advancePayments() {
      return this.$store.getters['advancePayments/byInvoice'](this.invoice.id);
    },
    colspan() {
      return 4 + this.taxes.length;
    },
  },
  methods: {
    updateProp(props) {
      this.$emit('update', props);
    },
    addPayment() {
      this.$store.dispatch('advancePayments/addAdvancePayment', this.invoice.id);
    },
    removePayment(paymentId) {
      this.$store.dispatch('advancePayments/removeAdvancePayment', paymentId);
    },
    updatePayment(props, payment) {
      this.$store.dispatch('advancePayments/updateAdvancePayment', {
        id: payment.id,
        props,
        invoiceId: this.invoice.id,
      });
    },
  },
};
</script>
